import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'antd-mobile-v5'
import { WhiteSpace, WingBlank } from 'antd-mobile'
import { ExclamationCircleFill } from 'antd-mobile-icons'
import styles from './FindAccount.module.css'
import { useIntl } from 'react-intl'

const FindFailure = ({ setVisible }) => {
  const { push } = useHistory()
  const { formatMessage } = useIntl()

  return (
    <WingBlank size="lg">
      <WhiteSpace size="lg" />
      <WhiteSpace size="lg" />
      <WhiteSpace size="lg" />
      <div className={styles['status-icon']}>
        <ExclamationCircleFill fontSize={58} color="var(--adm-color-danger)" />
      </div>
      <WhiteSpace size="lg" />
      <WhiteSpace size="lg" />
      <WhiteSpace size="lg" />
      <div>{formatMessage({ id: 'findme-not-find' })}</div>
      <WhiteSpace size="lg" />
      <Button color="primary" fill="none" block onClick={() => setVisible(true)}>
        {formatMessage({ id: 'findme-submit-email' })}
      </Button>
      <Button color="primary" fill="none" block onClick={() => push('/find_account/user_info')}>
        {formatMessage({ id: 'findme-fill-in-again' })}
      </Button>
    </WingBlank>
  )
}

export default FindFailure
